import * as CSS from './css';
import * as DOM from './dom';
import * as Debugger from './debugger';
import * as Input from './input';
import * as Network from './network';
import * as Overlay from './overlay';
import * as Page from './page';
import * as Runtime from './runtime';
import * as Target from './target';
import * as Webdriver from './webdriver';
import * as Redux from './redux';
import * as DOMStorage from './domStorage';

export default {
  CSS,
  DOM,
  Debugger,
  Input,
  Network,
  Overlay,
  Page,
  Runtime,
  Target,
  Webdriver,
  Redux,
  DOMStorage,
};
